import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DetailsPanel } from "@/components/common";
import { ProjectOverviewDisplay } from "@/components/project/editor";

/**
 * Displays the project overview panel.
 */
const __default__ = {
  name: "ProjectOverviewPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "displayProject",
    "data-cy": "panel-artifact-type"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ProjectOverviewDisplay), { borderless: "" })
    ]),
    _: 1
  }))
}
}

})